import { all, takeEvery, put, call } from 'redux-saga/effects'
import { withCallback } from 'redux-saga-callback'
import { store as reduxStore } from 'index'
import { push } from 'react-router-redux'
import { message } from 'antd'
import _ from 'lodash'

import {
  list as botsList,
  get as botGet,
  add as botAdd,
  update as botUpdate,
  del as botDelete,
} from 'services/aiBots'

import {
  list as personalitiesList,
  get as personalityGet,
  add as personalityAdd,
  update as personalityUpdate,
  del as personalityDelete,
} from 'services/aiPersonalities'

import appsPostOrDelete, {
  appsGetSettings,
  settingsUpdate,
  appsGetFeatures,
  settingsPostOrDelete,
} from 'services/ai'
import { settingsGet } from 'services/apps'

import { getAppHost } from 'helpers'

import actions from './actions'

/* BOTS */
export function* BOTS_LIST({ payload }) {
  yield put({
    type: 'ai/SET_STATE',
    payload: {
      loading: true,
      areAIBotsLoading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
  const botsPagination = reduxStore.getState().ai.botsListPagination

  let pageNo = payload.currentPage
  if (pageNo === undefined && botsPagination.current_page !== undefined)
    pageNo = botsPagination.current_page + 1

  const success = yield call(botsList, payload.data, getAppHost(payload.appSettings), pageNo)

  if (success && success.data) {
    let totalBotCount = success.data.length
    let botsListPagination = []
    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalBotCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
      botsListPagination = success.meta.pagination
    }
    yield put({
      type: 'ai/SET_STATE',
      payload: {
        active: payload.data,
        botsList: success.data,
        botsListTotal: totalBotCount,
        botsListPagination,
        loading: false,
        areAIBotsLoading: false,
      },
    })
  } else {
    yield put({
      type: 'ai/SET_STATE',
      payload: {
        botsList: [],
        botsListTotal: 0,
        botsListPagination: [],
        loading: false,
        areAIBotsLoading: false,
      },
    })
  }
}

/* BOT GET */

export function* GET_BOT({ payload }) {
  yield put({
    type: 'ai/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { id } = payload
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  const success = yield call(botGet, id, payload.data, getAppHost(payload.appSettings))

  if (success && success.data) {
    yield put({
      type: 'ai/SET_STATE',
      payload: {
        botsActive: success.data,
        loading: false,
      },
    })
  } else {
    yield put(push(`/app/${payload.data.id}/ai-bots`))
  }
}

/* BOT ADD */

export function* ADD_BOT({ payload }) {
  yield put({
    type: 'ai/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(botAdd, payload, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    yield put({
      type: 'ai/BOTS_LIST',
      payload: { currentPage: 1, data: activeApp },
    })

    yield put(push(`/app/${activeApp.id}/ai-bots`))
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Agent added' },
    })
  } else {
    yield put({
      type: 'ai/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      message.error(success.error.message)
    } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Plan restriction - Feature not available',
        },
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
}

/* BOT UPDATE */

export function* UPDATE_BOT({ id, payload }) {
  yield put({
    type: 'ai/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const filtered = {}
  const unset = []
  _.filter(payload, function fn(n, k) {
    if (k === 'useBasicAuth' || k === 'enabled' || (payload[k] && _.trim(payload[k]) !== '')) {
      filtered[k] = n
    } else {
      unset.push(k)
    }
  })
  filtered.unset = unset

  const success = yield call(botUpdate, id, filtered, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    yield put({
      type: 'ai/SET_STATE',
      payload: {
        loading: false,
      },
    })

    yield put({
      type: 'ai/GET_BOT',
      payload: {
        id,
      },
    })

    yield put({
      type: 'ai/BOTS_LIST',
      payload: { currentPage: 1, data: activeApp },
    })

    // yield put(push(`/app/${activeApp.id}/agents/${id}/edit`))

    yield put(push(`/app/${activeApp.id}/ai-bots`))
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Agent saved' },
    })
  } else {
    yield put({
      type: 'ai/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      message.error(success.error.message)
    } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Plan restriction - Feature not available',
        },
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
  return success
}

/* BOT DELETE */

export function* DELETE_BOT({ payload }) {
  const { id, refresh } = payload

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const { botsListPagination } = reduxStore.getState().ai

  yield put({
    type: 'ai/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(botDelete, id, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    const botListPageNo =
      botsListPagination !== undefined && botsListPagination.count > 1
        ? botsListPagination.current_page
        : 1
    yield put({
      type: 'ai/BOTS_LIST',
      payload: { currentPage: botListPageNo, data: activeApp },
    })

    yield put({
      type: 'ai/SET_STATE',
      payload: {
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `Agent deleted` },
    })
    if (refresh) yield put(push(`/app/${activeApp.id}/ai-bots`))
  } else {
    yield put({
      type: 'ai/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    }
  }
}

/* CHANGE_BOT_STATUS */

export function* CHANGE_BOT_STATUS({ payload }) {
  const { id, status } = payload

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const allBots = reduxStore.getState().ai.botsList

  yield put({
    type: 'ai/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const data = { enabled: !status }

  const success = yield call(botUpdate, id, data, activeApp, getAppHost(appSettings))

  let successMessage

  if (success && success.data) {
    _.forEach(allBots, function fn(c, k) {
      if (c.uid === id) {
        if (allBots[k].enabled) {
          successMessage = 'disabled'
        } else {
          successMessage = 'enabled'
        }

        allBots[k].enabled = !allBots[k].enabled
      }
    })

    yield put({
      type: 'ai/SET_STATE',
      payload: {
        botsList: allBots,
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `Agent ${successMessage}` },
    })
  } else {
    yield put({
      type: 'ai/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    }
  }
}

/* personalities */

export function* PERSONALITIES_LIST({ payload = {} }) {
  yield put({
    type: 'ai/SET_STATE',
    payload: {
      loading: true,
      areAIPersonalitiesLoading: true,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
  if (!payload.limit) payload.limit = 10
  const personalitiesPagination = reduxStore.getState().ai.personalitiesListPagination

  let pageNo = payload.currentPage
  if (pageNo === undefined && personalitiesPagination.current_page !== undefined)
    pageNo = personalitiesPagination.current_page + 1

  const success = yield call(
    personalitiesList,
    payload.data,
    getAppHost(payload.appSettings),
    pageNo,
    payload.limit,
  )

  if (success && success.data) {
    let totalPersonalityCount = success.data.length
    let personalitiesListPagination = []
    if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
      totalPersonalityCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
      personalitiesListPagination = success.meta.pagination
    }
    yield put({
      type: 'ai/SET_STATE',
      payload: {
        active: payload.data,
        personalitiesList: success.data,
        personalitiesListTotal: totalPersonalityCount,
        personalitiesListPagination,
        loading: false,
        areAIPersonalitiesLoading: false,
      },
    })
  } else {
    yield put({
      type: 'ai/SET_STATE',
      payload: {
        personalitiesList: [],
        personalitiesListTotal: 0,
        personalitiesListPagination: [],
        loading: false,
        areAIPersonalitiesLoading: false,
      },
    })
  }
}
/* PERSONALITY GET */

export function* GET_PERSONALITY({ payload }) {
  yield put({
    type: 'ai/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const { id } = payload
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  const success = yield call(personalityGet, id, payload.data, getAppHost(payload.appSettings))

  if (success && success.data) {
    yield put({
      type: 'ai/SET_STATE',
      payload: {
        personalitiesActive: success.data,
        loading: false,
      },
    })
  } else {
    yield put(push(`/app/${payload.data.id}/ai-instructions`))
  }
}

/* PERSONALITY ADD */

export function* ADD_PERSONALITY({ payload }) {
  yield put({
    type: 'ai/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const success = yield call(personalityAdd, payload, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    yield put({
      type: 'ai/PERSONALITIES_LIST',
      payload: { currentPage: 1, data: activeApp },
    })

    yield put(push(`/app/${activeApp.id}/ai-instructions`))
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Instruction added' },
    })
  } else {
    yield put({
      type: 'ai/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      message.error(success.error.message)
    } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Plan restriction - Feature not available',
        },
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
}

/* PERSONALITY UPDATE */

export function* UPDATE_PERSONALITY({ id, payload }) {
  yield put({
    type: 'ai/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const filtered = {}
  const unset = []
  _.filter(payload, function fn(n, k) {
    if (k === 'useBasicAuth' || k === 'enabled' || (payload[k] && _.trim(payload[k]) !== '')) {
      filtered[k] = n
    } else {
      unset.push(k)
    }
  })
  filtered.unset = unset

  const success = yield call(personalityUpdate, id, filtered, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    yield put({
      type: 'ai/SET_STATE',
      payload: {
        loading: false,
      },
    })

    yield put({
      type: 'ai/GET_PERSONALITY',
      payload: {
        id,
      },
    })

    yield put({
      type: 'ai/PERSONALITIES_LIST',
      payload: { currentPage: 1, data: activeApp },
    })

    yield put(push(`/app/${activeApp.id}/ai-instructions`))
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: 'Instruction saved' },
    })
  } else {
    yield put({
      type: 'ai/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      message.error(success.error.message)
    } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Plan restriction - Feature not available',
        },
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
  return success
}

/* PERSONALITY DELETE */

export function* DELETE_PERSONALITY({ payload }) {
  const { id, refresh } = payload

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const { personalitiesListPagination } = reduxStore.getState().ai

  yield put({
    type: 'ai/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const success = yield call(personalityDelete, id, activeApp, getAppHost(appSettings))

  if (success && success.data) {
    const personalityListPageNo =
      personalitiesListPagination !== undefined && personalitiesListPagination.count > 1
        ? personalitiesListPagination.current_page
        : 1
    yield put({
      type: 'ai/PERSONALITIES_LIST',
      payload: { currentPage: personalityListPageNo, data: activeApp },
    })

    yield put({
      type: 'ai/SET_STATE',
      payload: {
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `Instruction deleted` },
    })
    if (refresh) yield put(push(`/app/${activeApp.id}/ai-instructions`))
  } else {
    yield put({
      type: 'ai/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST' || success.error.code === 'ERR_NOT_FOUND') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    }
  }
}

/* CHANGE_PERSONALITY_STATUS */

export function* CHANGE_PERSONALITY_STATUS({ payload }) {
  const { id, status } = payload

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  const allPersonalities = reduxStore.getState().ai.personalitiesList

  yield put({
    type: 'ai/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const data = { enabled: !status }

  const success = yield call(botUpdate, id, data, activeApp, getAppHost(appSettings))

  let successMessage

  if (success && success.data) {
    _.forEach(allPersonalities, function fn(c, k) {
      if (c.uid === id) {
        if (allPersonalities[k].enabled) {
          successMessage = 'disabled'
        } else {
          successMessage = 'enabled'
        }

        allPersonalities[k].enabled = !allPersonalities[k].enabled
      }
    })

    yield put({
      type: 'ai/SET_STATE',
      payload: {
        personalitiesList: allPersonalities,
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'success', message: `Instruction ${successMessage}` },
    })
  } else {
    yield put({
      type: 'ai/SET_STATE',
      payload: {
        loading: false,
      },
    })

    if (success.error.code === 'ERR_BAD_REQUEST') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    }
  }
}

/* UPDATE_SETTINGS */

export function* UPDATE_SETTINGS({ payload }) {
  try {
    yield put({
      type: 'ai/SET_STATE',
      payload: {
        loading: true,
      },
    })

    const activeApp = reduxStore.getState().apps.active
    const { updatedSettings } = payload

    const success = yield call(settingsUpdate, activeApp, updatedSettings)

    if (success && success.data) {
      const aiSettings = yield call(settingsGet, activeApp.id, activeApp)

      if (!aiSettings.data.parameters['features.ai.enabled']) {
        yield call(settingsPostOrDelete, activeApp, { enabled: true })
        yield put({
          type: 'apps/GET_APP_SETTINGS',
          data: activeApp,
        })
        yield put({
          type: 'apps/SET_STATE',
          payload: {
            loading: false,
          },
        })
      }

      yield put({
        type: 'ai/GET_SETTINGS',
      })

      yield put({
        type: 'ai/SET_STATE',
        payload: {
          loading: false,
        },
      })

      yield put(push(`/app/${activeApp.id}/chat-settings`))
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'success', message: 'AI settings saved' },
      })
    } else {
      yield put({
        type: 'ai/SET_STATE',
        payload: {
          loading: false,
        },
      })
      if (success.error.code === 'ERR_BAD_REQUEST') {
        message.error(success.error.message)
      } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: {
            type: 'error',
            message: 'Plan restriction - Feature not available',
          },
        })
      } else if (success.error.message !== undefined) {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: success.error.message },
        })
      } else {
        yield put({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: 'Some error occurred' },
        })
      }
    }
    return success
  } catch (e) {
    yield put({
      type: 'ai/SET_STATE',
      payload: {
        loading: false,
      },
    })
    yield put({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type: 'error', message: 'Some error occurred' },
    })
    console.log(e)
  }
}

/* GET_SETTINGS */

export function* GET_SETTINGS({ payload }) {
  yield put({
    type: 'ai/SET_STATE',
    payload: {
      loading: true,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active

  const success = yield call(appsGetSettings, payload.data)
  if (success && success.data) {
    yield put({
      type: 'ai/SET_STATE',
      payload: {
        settingsActive: success.data,
        loading: false,
      },
    })
  } else {
    yield put(push(`/app/${payload.data.id}/chat-settings`))
  }
}

/* Ai Lists */

export function* AI_LIST({ payload }) {
  yield put({
    type: 'ai/SET_STATE',
    payload: {
      loading: true,
    },
  })

  if (!payload?.data) payload.data = reduxStore.getState().apps.active

  const success = yield call(appsGetFeatures, payload.data)
  if (success && success.data) {
    yield put({
      type: 'ai/SET_STATE',
      payload: {
        aiList: success.data,
        loading: false,
      },
    })
  }
}

/* update Ai feature */

export function* UPDATE_AI_FEATURE({ payload }) {
  yield put({
    type: 'apps/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { updatedSettings, featureKey, featureLabel } = payload

  let successMessage

  if (updatedSettings.enabled) {
    successMessage = 'enabled'
  } else {
    successMessage = 'disabled'
  }

  const success = yield call(appsPostOrDelete, activeApp, updatedSettings, featureKey)

  if (success && success.data) {
    const settingSuccess = yield call(settingsGet, activeApp.id, activeApp)
    if (settingSuccess && settingSuccess.data) {
      yield put({
        type: 'apps/SET_STATE',
        payload: {
          appSettings: settingSuccess.data,
          loading: false,
        },
      })

      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'success', message: `${featureLabel} has been ${successMessage}.` },
      })
    }
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
  } else {
    yield put({
      type: 'apps/SET_STATE',
      payload: {
        loading: false,
      },
    })
    if (success.error.code === 'ERR_BAD_REQUEST') {
      message.error(success.error.message)
    } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: {
          type: 'error',
          message: 'Plan restriction - Feature not available',
        },
      })
    } else if (success.error.message !== undefined) {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: success.error.message },
      })
    } else {
      yield put({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Some error occurred' },
      })
    }
  }
  return success
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.BOTS_LIST, BOTS_LIST),
    takeEvery(actions.ADD_BOT, ADD_BOT),
    takeEvery(actions.UPDATE_BOT, withCallback(UPDATE_BOT)),
    takeEvery(actions.GET_BOT, GET_BOT),
    takeEvery(actions.DELETE_BOT, DELETE_BOT),
    takeEvery(actions.CHANGE_BOT_STATUS, CHANGE_BOT_STATUS),
    takeEvery(actions.PERSONALITIES_LIST, PERSONALITIES_LIST),
    takeEvery(actions.ADD_PERSONALITY, ADD_PERSONALITY),
    takeEvery(actions.UPDATE_PERSONALITY, withCallback(UPDATE_PERSONALITY)),
    takeEvery(actions.GET_PERSONALITY, GET_PERSONALITY),
    takeEvery(actions.DELETE_PERSONALITY, DELETE_PERSONALITY),
    takeEvery(actions.CHANGE_PERSONALITY_STATUS, CHANGE_PERSONALITY_STATUS),
    takeEvery(actions.UPDATE_SETTINGS, UPDATE_SETTINGS),
    takeEvery(actions.AI_LIST, AI_LIST),
    takeEvery(actions.UPDATE_AI_FEATURE, UPDATE_AI_FEATURE),
  ])
}
